import React from 'react';
import { Typography, Box, Button, IconButton, Fade, Paper, useMediaQuery, useTheme } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

interface PolicyPageProps {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}

const PolicyPage: React.FC<PolicyPageProps> = ({ title, icon, children }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Fade in={true} timeout={800}>
      <Paper component="main" elevation={3} sx={{ 
        p: { xs: 2, sm: 3, md: 4 },
        my: { xs: 2, md: 4 },
        borderRadius: { xs: '12px', md: '16px' },
        maxWidth: "lg",
        mx: "auto"
      }}>
        <Box sx={{ 
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
          mb: 3,
          gap: isMobile ? 1 : 0
        }}>
          <IconButton 
            color="primary" 
            onClick={() => navigate('/')}
            aria-label="Back to home"
            sx={{ mr: isMobile ? 0 : 2 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center',
            width: isMobile ? '100%' : 'auto'
          }}>
            {React.cloneElement(icon as React.ReactElement, { 
              sx: { 
                mr: 1, 
                color: '#1976d2', 
                fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2rem' } 
              } 
            })}
            <Typography component="h1" variant="h3" gutterBottom sx={{ 
              mb: 0,
              fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2.2rem' }
            }}>
              {title}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ mt: { xs: 2, md: 3 }, px: { xs: 0, md: 2 } }}>
          {children}

          <Box sx={{ 
            mt: 5, 
            display: 'flex',
            justifyContent: 'center' 
          }}>
            <Button 
              variant="contained" 
              onClick={() => navigate('/')}
              sx={{ 
                borderRadius: '8px',
                textTransform: 'none',
                px: { xs: 2, md: 3 },
                py: { xs: 1, md: 1.5 },
                fontSize: { xs: '0.9rem', md: '1rem' }
              }}
            >
              Back to Home
            </Button>
          </Box>
        </Box>
      </Paper>
    </Fade>
  );
};

export default PolicyPage; 